<div class="container" [ngStyle]="maxWidth && {'max-width' : maxWidth}">
    <div>
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </div>
</div>

<ng-template #contentTpl>
    <ng-content></ng-content>
</ng-template>
